import React, { Component } from "react";
import LayoutSinNavegacion from "../../components/Layout/LayoutSinNavegacion";

class NotFound extends Component {
  render() {
    return (
      <LayoutSinNavegacion>
        <div className="error mx-auto" data-text="404">
          404
        </div>
        <p className="lead text-gray-800 mb-5">Página no encontrada.</p>
        <button
          class="btn btn-primary btn-icon-split text-center"
          onClick={this.props.history.goBack}
        >
          <span class="icon text-white-50">
            <i class="fas fa-arrow-alt-circle-left"></i>
          </span>
          <span class="text">Regresar</span>
        </button>
      </LayoutSinNavegacion>
    );
  }
}

export default NotFound;
